// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionInput } from './ConditionInput';
import {
  ConditionInputFromJSON,
  ConditionInputFromJSONTyped,
  ConditionInputToJSON,
  ConditionInputToJSONTyped,
} from './ConditionInput';
import type { ClusterStatusObservationInput } from './ClusterStatusObservationInput';
import {
  ClusterStatusObservationInputFromJSON,
  ClusterStatusObservationInputFromJSONTyped,
  ClusterStatusObservationInputToJSON,
  ClusterStatusObservationInputToJSONTyped,
} from './ClusterStatusObservationInput';

/**
 *
 * @export
 * @interface ClusterStatusPatch
 */
export interface ClusterStatusPatch {
  /**
   *
   * @type {ClusterStatusObservationInput}
   * @memberof ClusterStatusPatch
   */
  clusterStatus?: ClusterStatusObservationInput;
  /**
   *
   * @type {Array<ConditionInput>}
   * @memberof ClusterStatusPatch
   */
  conditions?: Array<ConditionInput>;
}

/**
 * Check if a given object implements the ClusterStatusPatch interface.
 */
export function instanceOfClusterStatusPatch(
  value: object,
): value is ClusterStatusPatch {
  return true;
}

export function ClusterStatusPatchFromJSON(json: any): ClusterStatusPatch {
  return ClusterStatusPatchFromJSONTyped(json, false);
}

export function ClusterStatusPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterStatusPatch {
  if (json == null) {
    return json;
  }
  return {
    clusterStatus:
      json['cluster_status'] == null
        ? undefined
        : ClusterStatusObservationInputFromJSON(json['cluster_status']),
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(ConditionInputFromJSON),
  };
}

export function ClusterStatusPatchToJSON(json: any): ClusterStatusPatch {
  return ClusterStatusPatchToJSONTyped(json, false);
}

export function ClusterStatusPatchToJSONTyped(
  value?: ClusterStatusPatch | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cluster_status: ClusterStatusObservationInputToJSON(value['clusterStatus']),
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(ConditionInputToJSON),
  };
}
